import { put, call, take, fork } from 'redux-saga/effects'
import { cardPatchService } from '../../api/card'
//import { questionPatchSuccess } from '../../reducers/question/action'
import { cardPatchSuccess } from '../../reducers/card/action'
import { CARD_PATCH } from '../../reducers/card/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'
import { editorLoading } from 'src/reducers/card/action'
import { useDispatch } from 'react-redux'
/**
 *
 * @param {*} payload
 */
function* cardPatchFlow(payload) {
  try {
    const { content, callback } = payload
    yield call(cardPatchService, content)
    yield put(cardPatchSuccess(content))
    yield put(operationSuccess())
    callback()
  } catch (error) {
    const { content } = payload
    const isTextChanging = content.contents.find(x => x.path == 'text')
    if (isTextChanging) {
      yield put(editorLoading(true))
      return
    }
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* cardPatchWatcher() {
  while (true) {
    const action = yield take(CARD_PATCH)
    const { payload } = action

    yield fork(generalSaga, cardPatchFlow, payload, false)
  }
}
